"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var xml2js = require("xml2js");
require("../extensions/globals");
var Send = /** @class */ (function () {
    function Send(config, book, $interpolate, uploads, appState, textResolver, testFeatures, pngExport) {
        this.config = config;
        this.book = book;
        this.$interpolate = $interpolate;
        this.uploads = uploads;
        this.appState = appState;
        this.textResolver = textResolver;
        this.testFeatures = testFeatures;
        this.pngExport = pngExport;
        this.imagePrefix = Math.floor(Math.random() * (100000) + 1).toString();
        this.builder = new xml2js.Builder();
        this.version = Object.assign({
            appDate: undefined,
            appHash: undefined,
            appVersion: undefined,
            configVersion: config.configJson.version,
            userAgent: navigator.userAgent
        }, window["pbAppVersion"]);
        this.api = window[config.params.apiName];
        if (!this.api || !this.api.hasOwnProperty('sendConfig')) {
            throw new Error("api method not available: \"window." + config.params.apiName + ".sendConfig\"");
        }
    }
    Send.prototype.send = function (type) {
        this.uploadDetails = this.uploads.getUploads();
        this.appState.saved = true;
        var outputObject = this.getOutputObject();
        var outputXml = this.getXmlOutput(outputObject);
        return this.api.sendConfig(outputObject, outputXml, type);
    };
    Send.prototype.sendMail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var outputObject;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.appState.saved = true;
                        return [4 /*yield*/, this.pngExport.getPng().then(function (result) {
                                outputObject = _this.getMailOutput(result);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.api.sendMail(outputObject)];
                }
            });
        });
    };
    Send.prototype.toBasket = function () {
        return this.send('basket');
    };
    Send.prototype.toUrl = function () {
        return this.send('url');
    };
    Send.prototype.toCollection = function () {
        return this.send('collection');
    };
    Send.prototype.toMail = function () {
        return this.sendMail();
    };
    Send.prototype.getXmlOutput = function (object) {
        var params = [];
        var formGroups = object.options;
        // prepare root-object:
        var json2xml = {
            book: {
                $: {
                    configId: object.configId,
                    xmlVersion: object.version.configVersion || '',
                    configName: object.configName,
                    dateTime: object.dateTime,
                    inDesignID: object.bookId,
                    partnerId: object.partnerId,
                    pagecount: typeof object.pagecount !== 'undefined' ? object.pagecount : '',
                    langBook: object.language.book,
                    langUI: object.language.ui
                },
                param: []
            }
        };
        // prepare params
        for (var _i = 0, _a = Object.entries(formGroups); _i < _a.length; _i++) {
            var _b = _a[_i], groupName = _b[0], group = _b[1];
            for (var _c = 0, _d = Object.entries(group); _c < _d.length; _c++) {
                var _e = _d[_c], formName = _e[0], value = _e[1];
                var values = void 0;
                if (typeof value === 'string') {
                    values = [value];
                }
                else if (typeof value === 'number') {
                    values = [value.toString()];
                }
                else if (Object.prototype.toString.call(value) === '[object Array]') {
                    values = value;
                }
                else {
                    values = Object.keys(value);
                }
                var param = {
                    $: {
                        formID: groupName,
                        paramID: formName
                    },
                    select: []
                };
                for (var _f = 0, values_1 = values; _f < values_1.length; _f++) {
                    var value_1 = values_1[_f];
                    var attributes = this.getMissingAttributes(groupName, formName, value_1);
                    var text = attributes.text;
                    delete attributes.text;
                    param.select.push({
                        _: text || '',
                        $: attributes
                    });
                }
                params.push(param);
            }
        }
        json2xml.book.param = params;
        return this.builder.buildObject(json2xml);
    };
    Send.prototype.getMailOutput = function (image) {
        return {
            bookId: this.config.params.bookId,
            version: this.version,
            configId: this.config.params.configId || '',
            partnerId: this.config.params.partnerId || '',
            configName: this.interpolate(this.config.configJson.name),
            language: {
                book: this.config.params.langBook,
                ui: this.config.params.langUI
            },
            dateTime: this.getDateTime(),
            options: Object.assign({}, this.book),
            image: image
        };
    };
    Send.prototype.getOutputObject = function () {
        var output = {
            bookId: this.config.params.bookId,
            version: this.version,
            configId: this.config.params.configId || '',
            configLink: this.config.params.configLink,
            partnerId: this.config.params.partnerId || '',
            configName: this.interpolate(this.config.configJson.name),
            language: {
                book: this.config.params.langBook,
                ui: this.config.params.langUI
            },
            pagecount: this.getPageCount(this.config.configJson.pagecount),
            dateTime: this.getDateTime(),
            options: Object.assign({}, this.book),
            uploads: this.uploadDetails
        };
        return output;
    };
    Send.prototype.getMissingAttributes = function (group, form, value) {
        var configForms = this.config.configJson.forms;
        var textTypes = ['text', 'textarea', 'textarea-lf', 'autotext', 'tel', 'number', 'letters', 'gm-places', 'counter'];
        var uploadTypes = ['upload', 'gm-static'];
        var attributes;
        for (var _i = 0, configForms_1 = configForms; _i < configForms_1.length; _i++) {
            var configForm = configForms_1[_i];
            if (configForm.id === group + "." + form) {
                var radioInputStandard = false;
                if (configForm.type === 'glyphs') {
                    configForm = this.config.configJson.glyphs;
                }
                for (var _a = 0, _b = configForm.options; _a < _b.length; _a++) {
                    var configOption = _b[_a];
                    // text inputs:
                    if (textTypes.includes(configForm.type)) {
                        attributes = {
                            selectID: this.$interpolate(configOption.$selectID || form || '')(this.book),
                            inDesignID: this.$interpolate(configOption.$inDesignID || '')(this.book),
                            text: this.book[group][form]
                        };
                        // upload options:
                    }
                    else if (uploadTypes.includes(configForm.type)) {
                        attributes = {
                            selectID: configOption.$selectID || form,
                            inDesignID: configOption.$inDesignID || '',
                            text: value
                        };
                        var upload = this.uploadDetails.find(function (upload) { return upload.option === group + "." + form; });
                        if (upload && upload.id) {
                            Object.assign(attributes, { identifier: upload.id });
                        }
                        // radio-inputs:
                    }
                    else if (configForm.type === 'radio-input') {
                        if (!configOption.custom && configOption.value === value) {
                            radioInputStandard = true;
                            attributes = {
                                selectID: value,
                                inDesignID: configOption.$inDesignID || '',
                                text: configOption.$textValue ? this.interpolate(configOption.$textValue) : ''
                            };
                            break;
                        }
                        // options with multiple properties:
                    }
                    else if (configOption.hasOwnProperty('property')) {
                        if (configOption.property === value) {
                            attributes = {
                                selectID: value,
                                inDesignID: configOption.$inDesignID || '',
                                text: this.book[group][form][value]
                            };
                            break;
                        }
                        // other options:
                    }
                    else {
                        if (configOption.value === value) {
                            attributes = {
                                selectID: value,
                                inDesignID: configOption.$inDesignID || '',
                                text: configOption.$textValue ? this.interpolate(configOption.$textValue) : ''
                            };
                            break;
                        }
                    }
                }
                if (configForm.type === 'radio-input' && !radioInputStandard) {
                    for (var _c = 0, _d = configForm.options; _c < _d.length; _c++) {
                        var configOption = _d[_c];
                        if (configOption.custom) {
                            attributes = {
                                selectID: configOption.$selectID || 'custom',
                                inDesignID: configOption.$inDesignID || 'custom',
                                text: value
                            };
                            break;
                        }
                    }
                }
                break;
            }
        }
        return attributes;
    };
    Send.prototype.interpolate = function (expression) {
        var result = this.$interpolate(expression)(Object.assign({}, this.book, {
            resolve: this.textResolver.resolve.bind(this.textResolver),
            hasFeature: this.testFeatures.hasFeature.bind(this.testFeatures)
        }));
        return result;
    };
    Send.prototype.getPageCount = function (expression) {
        var pagecount;
        if (typeof expression === 'number' || typeof expression === 'string') {
            pagecount = parseInt(this.interpolate(expression.toString()), 10);
            if (pagecount > 0) {
                pagecount = Math.ceil(pagecount / 4) * 4;
            }
        }
        return pagecount;
    };
    Send.prototype.getDateTime = function () {
        var d = new Date();
        var str = d.getDate() + "." + (d.getMonth() + 1) + "." + d.getFullYear() + " "
            + (d.getHours() + ":" + d.getMinutes());
        return str;
    };
    return Send;
}());
exports.Send = Send;
exports.default = angular.module('pb.send', [])
    .service('send', Send);
